var _defineProperty = require("/home/circleci/project/website/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/home/circleci/project/website/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var breakpoints = Object.entries({
  '--medium-phone': 368,
  '--large-phone': 416,
  '--small-tablet': 544,
  '--tablet': 768,
  '--desktop': 992,
  '--large-desktop': 1280,
  '--xlarge-desktop': 1440,
  '--xxlarge-desktop': 1920,
  '--4k-desktop': 2560
});
var customMedia = breakpoints.reduce(function (media, _ref, index) {
  var _ref2 = _slicedToArray(_ref, 2),
      breakpoint = _ref2[0],
      pixels = _ref2[1];

  var min = "(min-width: ".concat(pixels, "px)");

  var newMedia = _defineProperty({}, breakpoint, min);

  if (index + 1 < breakpoints.length) {
    var max = "(max-width: ".concat(breakpoints[index + 1][1] - 1, "px)");
    newMedia["".concat(breakpoint, "-max")] = max;
    newMedia["".concat(breakpoint, "-exact")] = "".concat(min, " and ").concat(max);
  }

  return _objectSpread(_objectSpread({}, media), newMedia);
}, {}); // CommonJS export format required by PostCSS plugin.

module.exports = {
  customMedia: customMedia
};